import { render, staticRenderFns } from "./BuildingView.vue?vue&type=template&id=4381881b&scoped=true&"
import script from "./BuildingView.vue?vue&type=script&lang=js&"
export * from "./BuildingView.vue?vue&type=script&lang=js&"
import style0 from "./BuildingView.vue?vue&type=style&index=0&id=4381881b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4381881b",
  null
  
)

/* custom blocks */
import block0 from "./BuildingView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports